import { DOMParser } from "prosemirror-model"
import { EditorState } from "prosemirror-state"
import { EditorView } from "prosemirror-view"

import schema from "@components/Editor/builder/editor-schema"
import { exampleSetup } from "@components/Editor/builder/editor-plugin"

export const createEditor = ({ el, value = "" }) => {
    const content = document.createElement("div")
    content.innerHTML = value

    const state = EditorState.create({
        doc: DOMParser.fromSchema(schema).parse(content),
        plugins: exampleSetup({ schema: schema })
    })

    return new EditorView(el, { state })
}
